import React from 'react';

import { MCButton, SelectField, TabMenu } from 'src/components/basic';
import { popupModel } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';
import TreatmentsList from 'src/components/treatments/list';
import AddAnalyse from 'src/components/analyse/create';
import AnalysesList from 'src/components/analyse/list';
import CreateTimeline from 'src/components/timeline/create';
import TimelineList from 'src/components/timeline/list';
import AppointmentList from 'src/components/appointments/list';

import { isAdminPage, lang, permissions, remCss } from 'src/helpers';

import treatmentsModel from './treatmentsModel';
import analysesModel from './analysesModel';
import timelineModel from './timelineModel';
import model from './appointmentsModel';

const { PAGES, ACTIONS } = permissions;

const tabs = [
  { id: 'appointments', name: 'Appointments' },
  { id: 'treatments', name: 'Treatments' },
  { id: 'analyses', name: 'Analyses' },
  { id: 'timeline', name: 'Journey' }
];

class Index extends BaseComponent {
  state = { activeTab: 'appointment' };

  componentDidMount() {
    model.subscribe(this.subscription);
    if (this.props.router.params?.tab !== this.state.activeTab) {
      this.setState({ activeTab: this.props.router.params.tab });
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  add = () => {
    const { activeTab } = this.state;
    const { patient, user } = model.state;
    switch (activeTab) {
      case 'appointments':
        if (user.isDoctor) this.navigate(PAGES.PATIENTS_APPOINTMENT_BOOK_PAGE.match(patient.id));
        else this.navigate(PAGES.SCHEDULE_PAGE.path);
        break;
      case 'treatments':
        this.navigate(permissions.PAGES.CREATE_TREATMENTS_PAGE.match(patient.id));
        // popupModel.setActivePopup('add_treatment', {
        //   active: true,
        //   component: AddTreatment,
        //   props: { model: treatmentsModel }
        // });
        break;
      case 'analyses':
        popupModel.setActivePopup('add_analyse', {
          active: true,
          component: AddAnalyse,
          props: { model: analysesModel }
        });
        break;
      case 'timeline':
        popupModel.setActivePopup('add_timeline', {
          active: true,
          component: CreateTimeline,
          props: { model: timelineModel }
        });
        break;
    }
  };

  render() {
    const { activeTab = 'appointments' } = this.state;
    const { patient } = model.state;
    let isActiveBtn = activeTab !== 'timeline' && !isAdminPage();

    if (activeTab === 'appointments') isActiveBtn = PAGES.APPOINTMENTS_BOOK_PAGE?.isActive;
    if (activeTab === 'treatments') isActiveBtn = ACTIONS.TREATMENTS_ADD_BUTTON.isActive;
    if (activeTab === 'analyses') isActiveBtn = ACTIONS.ANALYSES_ADD_BUTTON.isActive;

    return (
      <div className={'mc-container-content__body mc-grow'} style={{ minHeight: remCss(380) }}>
        <div className={'mc-container-content__body-header'} style={{ zIndex: 2 }}>
          <div>
            <TabMenu
              type={'button-2'}
              tabs={tabs}
              tab={{ id: activeTab }}
              setTab={(v) => {
                this.props.router.navigate(
                  isAdminPage()
                    ? PAGES.ADMIN_PATIENTS_DETAIL_PAGE.match(patient.id, v.id)
                    : PAGES.PATIENTS_DETAIL_PAGE.match(patient.id, v.id),
                  {
                    replace: true
                  }
                );
                this.setState({ activeTab: v.id });
              }}
              className={'mc-mobile'}
            />
          </div>
          <div className={'mc-grow'} />
          <div className={'mc-flex'}>
            {activeTab === 'appointments' && (
              <SelectField
                width={remCss(150)}
                options={[
                  { value: 'all', label: 'All' },
                  { value: 'upcoming', label: 'Upcoming' },
                  { value: 'attended', label: 'Past' }
                ]}
                template={5}
                isClearable={false}
                name={'statusGroup'}
                value={model.input('statusGroup')}
                onChange={(name, v) => {
                  model.handleChange('statusGroup', v);
                  model.setListState({ items: [], total: 0 });
                  model.refresh();
                }}
              />
            )}
            {isActiveBtn && (
              <MCButton
                primary
                radius
                medium
                style={{ height: remCss(50) }}
                dark
                onClick={this.add}
              >
                {lang.t('Add ' + activeTab.substring(0, activeTab.length - 1))}
              </MCButton>
            )}
          </div>
        </div>
        <div className={'mc-tab-box-opacity'} style={{ zIndex: 1 }}>
          <div
            className={
              'mc-tab-content mc-flex-col ' + (activeTab === 'appointments' ? '' : 'mc-inactive')
            }
          >
            <AppointmentList model={model} />
          </div>
          <div
            className={
              'mc-tab-content mc-flex-col ' + (activeTab === 'treatments' ? '' : 'mc-inactive')
            }
          >
            <TreatmentsList
              model={treatmentsModel}
              onlyMine={true}
              onSeeMore={(treatment) => {
                this.navigate(
                  isAdminPage()
                    ? PAGES.ADMIN_PATIENTS_DETAIL_TREATMENT_DETAIL_PAGE.match(
                        patient.id,
                        treatment.id
                      )
                    : PAGES.PATIENTS_DETAIL_TREATMENT_DETAIL.match(patient.id, treatment.id),
                  {
                    state: { treatment }
                  }
                );
              }}
            />
          </div>
          <div
            className={
              'mc-tab-content mc-flex-col ' + (activeTab === 'analyses' ? '' : 'mc-inactive')
            }
          >
            <AnalysesList model={analysesModel} onlyMine={true} />
          </div>
          <div
            className={
              'mc-tab-content mc-flex-col ' + (activeTab === 'timeline' ? '' : 'mc-inactive')
            }
          >
            <TimelineList
              onlyMine={true}
              enableAdd={false}
              showCategory={false}
              selectJourney={timelineModel.selectJourney}
              journeys={timelineModel.listInput('journeys') || []}
              journey={timelineModel.listInput('journey')}
              journeyId={timelineModel.listInput('journeyId')}
              model={timelineModel}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
